module.exports = __webpack_public_path__ + "media/images/icons/courses/5-0e9a9b9accaae022910527446d8a95e4.svg";